/// <reference types="./endpoints.d.mts" />
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $vitools from "../../vitools/vitools.mjs";
import * as $mode from "../../vitools/vitools/mode.mjs";
import { Ok } from "../gleam.mjs";

export function frontend() {
  let $ = $vitools.get_env("APP_ENDPOINT");
  if ($ instanceof Ok) {
    let value = $[0];
    return value;
  } else {
    let $1 = $mode.mode();
    if ($1 instanceof $mode.Production) {
      return "https://app.steerlab.ai";
    } else if ($1 instanceof $mode.Staging) {
      return "https://steerlab.dev";
    } else if ($1 instanceof $mode.Development) {
      return "http://localhost:5173";
    } else {
      return "http://127.0.0.1:5173";
    }
  }
}

function api() {
  let $ = $vitools.get_env("API_ENDPOINT");
  if ($ instanceof Ok) {
    let value = $[0];
    return value;
  } else {
    let $1 = $mode.mode();
    if ($1 instanceof $mode.Production) {
      return "https://api.steerlab.ai";
    } else if ($1 instanceof $mode.Staging) {
      return "https://api.steerlab.dev";
    } else if ($1 instanceof $mode.Development) {
      return "http://localhost:3000";
    } else {
      return "http://127.0.0.1:3000";
    }
  }
}

export function heimdall() {
  return api() + "/heimdall";
}

export function loki() {
  return api() + "/loki";
}

export function nabu() {
  return api() + "/nabu";
}

export function hermes() {
  let $ = $mode.dev();
  if ($) {
    return api() + "/hermes/slack/redirect";
  } else {
    return api() + "/hermes";
  }
}

export function wss() {
  let _pipe = api();
  let _pipe$1 = $string.replace(_pipe, "http", "ws");
  let _pipe$2 = $string.replace(_pipe$1, "https", "wss");
  return $string.append(_pipe$2, "/wss");
}
